// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

import HelloController from "./hello_controller"
import DialogController from "./dialog_controller"
import PricingController from "./pricing_controller"
import Clipboard from '@stimulus-components/clipboard'
import CountDownController from './countdown_controller'

application.register("hello", HelloController)
application.register("dialog", DialogController)
application.register("pricing", PricingController)
application.register('clipboard', Clipboard)
application.register('countdown', CountDownController)
